import React, { useState, useEffect } from "react";
import axios from "axios";

import {
  PLATFORM_STATIC_ICONS,
  VIDEO_PLACEHOLDER,
} from "../../../config/icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faClapperboardPlay,
  faPlay,
  faFilePdf,
} from "@fortawesome/pro-duotone-svg-icons";
import { faXmark } from "@fortawesome/pro-solid-svg-icons";
import ProgressBar from "react-bootstrap/ProgressBar";
import toast from "react-hot-toast";

import { useTranslate } from "@tolgee/react";
import { useDispatch, useSelector } from "react-redux";
import {
  clearImageThumbnail,
  deleteAfile,
  editImageThumbnail,
  fileUploadStatus,
  setModalUiContent,
} from "../../../redux/slices/lomavisCreator/lomavisCreator";
import { lomavisCreatorRootState } from "../../../pages/lomavisCreator";
import axiosClient from "../../../utils/axios";
import ImageWithLoading from "../components/commonElements/imageWithLoading";

interface Props {
  platform: string;
}
interface MediaObject {
  uploaded: boolean;
  id: string;

  // Other properties...
}

const ThumbnailPreviewCard: React.FC<Props> = ({ platform }) => {
  const [imageError, setImageError] = useState(false);
  const [progress, setProgress] = useState(0);
  const [uploading, setUploading] = useState(false);

  const { t } = useTranslate();
  const dispatch = useDispatch();
  const postData = useSelector(
    (state: lomavisCreatorRootState) => state.lomavisCreator.postData[platform]
  );
  const fullEditorImage = useSelector(
    (state: lomavisCreatorRootState) =>
      state.lomavisCreator.postData[platform]?.fullEditorImage
  );

  const editedThumbnail = useSelector(
    (state: lomavisCreatorRootState) =>
      state.lomavisCreator.postData[platform]?.editedImageThumbnail
  );
  const uploadedThumbnail = useSelector(
    (state: lomavisCreatorRootState) =>
      state.lomavisCreator.postData[platform]?.uploadedImageThumbnail
  );
  const layeredThumbnail = useSelector(
    (state: lomavisCreatorRootState) =>
      state.lomavisCreator.postData[platform]?.layeredImageThumbnail
  );
  const [deleting, setDeleting] = useState(false);

  const deleteAsset = async () => {
    const urlArray = [layeredThumbnail, editedThumbnail];
    dispatch(
      clearImageThumbnail({
        platform,
      })
    );

    setDeleting(true);
    try {
      // Create an array of promises
      const deletePromises = urlArray.map((item) => {
        // const apiUrl = item?.uploadPresets?.uploaded_object_data?.api_url;
        const apiUrl = item?.media?.api_url;

        if (!apiUrl) {
          dispatch(
            clearImageThumbnail({
              platform,
            })
          );
          setDeleting(false);
          return;
        }

        return axiosClient.delete(apiUrl);
      });

      // Await all promises
      const responses = await Promise.all(deletePromises);

      // Log responses
      responses.forEach((response) => {
        console.log("Response:", response.data);
      });
      setDeleting(false);
      // Dispatch the action current all deletes are done
      dispatch(
        clearImageThumbnail({
          platform,
        })
      );
    } catch (error) {
      // Handle error
      dispatch(
        clearImageThumbnail({
          platform,
        })
      );
      setDeleting(false);
      console.error("Error:", error);
    }
  };

  return (
    <div
      style={{ position: "relative" }}
      className={`position-relative d-flex justify-content-center align-items-center w-100`}
    >
      <div
        className="w-20px position-absolute bottom-0 end-0 d-flex justify-content-center align-item-center badge  cursor-pointer"
        style={{
          backgroundColor: "#adb5bd",
          alignItems: "center",
          zIndex: 10,
        }}
        onClick={() => {
          deleteAsset();
        }}
      >
        <div
          style={{
            aspectRatio: 1,
            alignItems: "center",
            zIndex: 10,
            cursor: "pointer",
          }}
          className="d-flex justify-content-center align-item-center rounded"
        >
          {deleting ? (
            <span
              style={{
                aspectRatio: 1,
                alignItems: "center",
              }}
              className="spinner-border spinner-border-sm text-white ratio ratio-1x1"
              role="status"
              aria-hidden="true"
            ></span>
          ) : (
            <span
              style={{
                aspectRatio: 1,
                alignItems: "center",
              }}
              className="text-white fw-bolder fs-7"
            >
              X
            </span>
          )}
        </div>
      </div>

      {/* {item.media_type !== "doc" && (
        <div
          style={{
            width: item.orientation === "landscape" ? "25%" : "15%",
            height: item.orientation === "portrait" ? "25%" : "15%",
            position: "absolute",
            backgroundColor: "white",
            borderRadius: "2px",
            bottom: "10px",
            right: "13px",
          }}
        ></div>
      )} */}

      <div
        style={{
          width: "100%",
          height: "100%",
          position: "absolute",
          borderRadius: "2px",
          margin: "0 auto 0 auto",
          zIndex: 9,
        }}
        className="d-flex justify-content-center align-items-center"
        onClick={() => {
          dispatch(
            setModalUiContent({
              modal: "thumbnail",
              attribute: "platform",
              value: platform,
            })
          );
          dispatch(
            setModalUiContent({
              modal: "thumbnail",
              attribute: "toggle",
              value: true,
            })
          );
        }}
      >
        <div
          style={{ aspectRatio: 1, zIndex: 20, minWidth: "40%" }}
          className="rounded-circle bg-white bg-opacity-50 d-flex justify-content-center align-items-center p-2"
        >
          <i
            style={{ fontSize: "24px" }}
            className="fa-duotone fa-pencil text-white"
          ></i>
        </div>
      </div>

      {!imageError && layeredThumbnail?.media?.preview_image ? (
        <div className={`d-flex justify-content-center align-items-center m-1`}>
          <ImageWithLoading
            src={layeredThumbnail?.media?.preview_image}
            alt="placeholder"
            className={"img-thumbnail m-1"}
            style={{
              objectFit: "contain",
              maxHeight: "100px",
              maxWidth: "100px",
            }}
          />
        </div>
      ) : (
        <div
          className={`bg-danger h-100px w-100px bg-dark bg-opacity-25 d-flex justify-content-center align-items-center border border-white border-3 rounded-2 m-1`}
        >
          <img
            className=""
            style={{ width: "50%", height: "50%" }}
            src={PLATFORM_STATIC_ICONS.video_placeholder}
          />
        </div>
      )}
    </div>
  );
};

export default ThumbnailPreviewCard;
